const DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;
const LEADING_DATE_PATTERN = /^(\d{4}-\d{2}-\d{2})/;

const pad2 = (value: number): string => String(value).padStart(2, '0');

const buildDateOnly = (year: number, month: number, day: number): string =>
  `${year}-${pad2(month)}-${pad2(day)}`;

const isValidDateOnly = (value: string): boolean => {
  const match = DATE_ONLY_PATTERN.exec(value);
  if (!match) return false;

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const date = new Date(year, month - 1, day);

  return (
    date.getFullYear() === year &&
    date.getMonth() + 1 === month &&
    date.getDate() === day
  );
};

export const toApiDateOnly = (
  value: string | Date | null | undefined
): string => {
  if (!value) return '';

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return '';

    const match = LEADING_DATE_PATTERN.exec(trimmed);
    if (!match) return '';

    return isValidDateOnly(match[1]) ? match[1] : '';
  }

  if (Number.isNaN(value.getTime())) return '';

  return buildDateOnly(
    value.getFullYear(),
    value.getMonth() + 1,
    value.getDate()
  );
};

export const fromApiDateOnly = (
  value: string | Date | null | undefined
): string => toApiDateOnly(value);

export const dateOnlyToPickerDate = (
  value: string | null | undefined
): Date | null => {
  const normalized = fromApiDateOnly(value);
  if (!normalized) return null;

  const match = DATE_ONLY_PATTERN.exec(normalized);
  if (!match) return null;

  return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
};

export const formatDateOnlyForDisplay = (
  value: string | Date | null | undefined
): string => {
  const normalized = fromApiDateOnly(value);
  if (!normalized) return '';

  const match = DATE_ONLY_PATTERN.exec(normalized);
  if (!match) return normalized;

  const date = new Date(
    Number(match[1]),
    Number(match[2]) - 1,
    Number(match[3])
  );
  return date.toLocaleDateString();
};
